import { IDisposable } from './Disposable';

export abstract class AudioData implements IDisposable {
  abstract dispose(): void;
}
